import classNames from 'classnames';
import { ComponentProps, FC, SyntheticEvent } from 'react';

import { Skeleton } from '@gem/ui-kit';

import { useRemoteImagePresenter } from './RemoteImage.presenter';
import styles from './RemoteImage.styles.m.css';

interface IRemoteImageProps extends ComponentProps<'img'> {
  src: string;
  isAnimatedReveal?: boolean;
  onLoad?(event?: SyntheticEvent): void;
  onError?(event?: SyntheticEvent): void;
}

export const RemoteImage: FC<IRemoteImageProps> = (props) => {
  const { src, className, style, alt, onLoad, onError, width, height, isAnimatedReveal } = props;
  const { presenter, imgRef } = useRemoteImagePresenter({
    src,
    onLoad,
    onError,
  });

  const rootClassName = classNames(styles.container, className, {
    [styles.isLoading]: presenter.isLoading,
    [styles.emptySrc]: !presenter.src,
    [styles.animatedReveal]: isAnimatedReveal,
  });

  return (
    <div className={rootClassName}>
      <div className={styles.wrapper}>
        <Skeleton
          isAnimated={presenter.isLoading}
          className={styles.loader}
          width={`${width}px`}
          height={`${height}px`}
        />
        <img
          ref={imgRef}
          className={classNames(styles.image, className)}
          style={style}
          src={presenter.src}
          alt={alt}
          onLoad={presenter.onLoad}
          onError={presenter.onError}
          width={width}
          height={height}
        />
      </div>
    </div>
  );
};
